import { useRef, useEffect } from 'react';
import echarts from 'echarts';
import { debounce } from 'lodash';

export default function useChart(options, onClick) {
  const domRef = useRef(null);
  const chart = useRef();
  const resizeChart = debounce(() => chart.current.resize(), 300);

  useEffect(() => {
    if (!domRef.current || !options) return;

    chart.current = echarts.init(domRef.current);
    chart.current.setOption(options);
    chart.current.on('click', onClick);
    window.addEventListener('resize', resizeChart);

    return () => {
      window.removeEventListener('resize', resizeChart);
      chart.current.dispose();
    };
  }, [onClick, options, resizeChart]);

  return domRef;
}
